import React from 'react'
import { Route } from 'react-router'

import { COMMENTS, OUTLINE } from 'data/ui/UrlPanelTypes'

import { MetabarWrapper, MetabarSeparator } from './Layout'
import MetaComments from './Comments'
import MetaOutline from './Outline'
import MetaUsers from './Users'
import MetaMore from './More'
import MetaPing from './Ping'
import MetaShare from './Share'
import MetaBookmark from './Bookmark'
import EditorNextLabel from './EditorNextLabel'

type MetabarContainerNotesShowProps = {
  noteId: string
  options?: string
}

function MetabarContainerNotesShow({
  noteId,
  options,
}: MetabarContainerNotesShowProps) {
  const isCommentsOpen = options === COMMENTS
  const isOutlineOpen = options === OUTLINE
  return (
    <React.Fragment>
      <MetaShare noteId={noteId} />
      <MetaPing noteId={noteId} />
      <MetaComments noteId={noteId} isCommentsOpen={isCommentsOpen} />
      <MetaOutline noteId={noteId} isOutlineOpen={isOutlineOpen} />
      <MetaBookmark noteId={noteId} />
      <MetaMore noteId={noteId} />
      <MetabarSeparator />
      <MetaUsers noteId={noteId} />
      <EditorNextLabel />
    </React.Fragment>
  )
}

export default function MetabarContainer() {
  return (
    <MetabarWrapper>
      <Route
        path="/app/*/notes/:noteId/:options?"
        render={({ match }) => {
          const { noteId, options } = match.params
          return <MetabarContainerNotesShow noteId={noteId} options={options} />
        }}
      />
    </MetabarWrapper>
  )
}
